import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { palette } from '@openx/components-core/lib/theme/paletteV2.ts';
import { abbreviateNumericValue } from '@openx/utils/lib/abbreviateNumericValue.ts';
import { toPercentString } from '@openx/utils/lib/toPercentString.ts';
import { useTranslation } from 'react-i18next';

type TooltipMetricsProps = {
  dataTestPrefix: string;
  impressions?: number | null;
  viewability?: number | null;
  vcr?: number | null;
};

export const TooltipMetrics = ({ dataTestPrefix, impressions, viewability, vcr }: TooltipMetricsProps) => {
  const { t } = useTranslation();

  return (
    <Box sx={{ borderTop: `1px solid ${palette.divider}`, pt: 1, mx: -2, px: 2, mb: 0 }}>
      <Box sx={{ display: 'flex', flexDirection: 'row', gap: 2, justifyContent: 'space-between' }}>
        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
          <Typography
            variant="caption"
            sx={{
              color: palette.text.secondary,
              fontSize: '0.75rem',
            }}
            data-test={`${dataTestPrefix}-impressions-label`}
          >
            {t('Impressions')}
          </Typography>
          {impressions != null ? (
            <Typography variant="body2Bold" data-test={`${dataTestPrefix}-impressions`}>
              {abbreviateNumericValue(impressions, { allowZero: true })}
            </Typography>
          ) : (
            <Typography variant="body2" sx={{ color: palette.text.secondary }}>
              {t('N/A')}
            </Typography>
          )}
        </Box>

        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
          <Typography
            variant="caption"
            sx={{
              color: palette.text.secondary,
              fontSize: '0.75rem',
            }}
            data-test={`${dataTestPrefix}-viewability-label`}
          >
            {t('Viewability')}
          </Typography>
          {viewability != null ? (
            <Typography variant="body2Bold" data-test={`${dataTestPrefix}-viewability`}>
              {toPercentString(viewability.toString(), { decimalPlaces: 2 })}
            </Typography>
          ) : (
            <Typography variant="body2" sx={{ color: palette.text.secondary }}>
              {t('N/A')}
            </Typography>
          )}
        </Box>

        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
          <Typography
            variant="caption"
            sx={{
              color: palette.text.secondary,
              fontSize: '0.75rem',
            }}
            data-test={`${dataTestPrefix}-vcr-label`}
          >
            {t('VCR')}
          </Typography>
          {vcr != null ? (
            <Typography variant="body2Bold" data-test={`${dataTestPrefix}-vcr`}>
              {toPercentString(vcr.toString(), { decimalPlaces: 2 })}
            </Typography>
          ) : (
            <Typography variant="body2" sx={{ color: palette.text.secondary }}>
              {t('N/A')}
            </Typography>
          )}
        </Box>
      </Box>
    </Box>
  );
};
